import React from 'react';

function Icon() {
  return (
    <svg
      width="17"
      height="15"
      viewBox="0 0 17 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 15L4.88 0.259999H7.56L12.44 15H9.98L7.6 7C7.36 6.2 7.12667 5.39333 6.9 4.58C6.67333 3.75333 6.44667 2.92667 6.22 2.1H6.14C5.92667 2.94 5.7 3.76667 5.46 4.58C5.23333 5.39333 5 6.2 4.76 7L2.38 15H0ZM2.76 10.82V8.98H9.64V10.82H2.76ZM14.5314 15V0.259999H16.8514V15H14.5314Z"
        fill="var(--text-color-3)"
      />
    </svg>
  );
}

export default Icon;
